import * as React from "react";
import { HandleThunkActionCreator } from "react-redux";
import { Link } from "react-router-dom";
import { updateStudent } from "../../../../actions/common/student";
import { useNavigationToggle } from "../../../../contexts/NavigationContext";
import { toJapanese as paidServiceToJapanese } from "../../../../domains/PaidService";
import { ApiErrorInterface } from "../../../../interfaces/ApiErrorResponseInterface";
import { OperatorPrivilegeInfoInterface } from "../../../../interfaces/OperatorInterface";
import SectionInterface from "../../../../interfaces/SectionInterface";
import {
  convertStudentFormValueToParams,
  StudentFormValueInterface,
  StudentWithStayInterface,
} from "../../../../interfaces/StudentInterface";
import { PaidServiceLabel } from "../../../features/PaidServiceLabel";
import StudentEditModal from "../../../molecules/StudentEditModal";
import { StudentAvatar } from "./StudentAvatar";
import styles from "./styles.scss";

interface Props {
  privileges: OperatorPrivilegeInfoInterface;
  student: StudentWithStayInterface;
  section: SectionInterface;
  submitting: boolean;
  apiErrors: ApiErrorInterface[];
  updateStudent: HandleThunkActionCreator<typeof updateStudent>;
}

const StudentNaviProfile = (props: Props) => {
  const { toggleNavigation } = useNavigationToggle();
  const [isOpen, setIsOpen] = React.useState(false);
  const handleSubmit = (values: StudentFormValueInterface) => {
    props.updateStudent(
      props.student.id,
      convertStudentFormValueToParams(values),
      () => setIsOpen(false),
    );
  };

  const handleClickMessage = () => {
    toggleNavigation();
  };

  return (
    <div className={styles.root}>
      <StudentAvatar stayStatus={props.student.stayStatus} />
      <div className={styles.fullName}>
        {props.privileges.role === "admin" ||
        props.privileges.role === "unlimited_member" ? (
          <button
            onClick={() => setIsOpen(true)}
            className={styles.studentEditBtn}
            aria-describedby="student-stay-status"
          >
            {props.student.fullName}
          </button>
        ) : (
          props.student.fullName
        )}
      </div>
      <div className={styles.job}>{`(${props.student.jobHuman})`}</div>
      <div className="flex flex-wrap justify-center gap-[8px] mt-[0.8rem] max-w-[22.4rem] mx-auto">
        {props.student.paidServices?.map((service) => (
          <PaidServiceLabel key={service.id}>
            {paidServiceToJapanese(service.name)}
          </PaidServiceLabel>
        ))}
      </div>
      <div>
        <Link
          to={`/students/${props.student.id}/messages`}
          onClick={handleClickMessage}
          className={`buiButtonBase buiButtonVariantFilled ${styles.messageLink}`}
        >
          メッセージ
        </Link>
      </div>
      <StudentEditModal
        isOpen={isOpen}
        student={props.student}
        handleClose={() => setIsOpen(false)}
        updateStudent={() => {}}
        forReduxProps={{
          submitting: props.submitting,
          onSubmit: handleSubmit,
          apiErrors: props.apiErrors,
        }}
      >
        <h2>生徒を編集</h2>
      </StudentEditModal>
    </div>
  );
};

export default StudentNaviProfile;
